import { toast, ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const customId = "custom-id-yes";

const options: ToastOptions = {
  hideProgressBar: true,
  position: 'bottom-center',
  autoClose: 3000,
  closeOnClick: true,
  draggable: false,
  toastId: customId,
};
const optionsInfo: ToastOptions = {
  type: 'info',
  ...options,
};
const optionsSuccess: ToastOptions = {
  type: 'success',
  ...options,
};
const optionsError: ToastOptions = {
  type: 'error',
  ...options,
};

function canBeRendered(content: any) {
  return (
    typeof content === "string" ||
    typeof content === "number" ||
    typeof content === "function"
  );
}

export const ToastNotifyInfo = (message: string) => {
  canBeRendered(message) && toast(message, optionsInfo);
};
export const ToastNotifySuccess = (message: string) => {
  canBeRendered(message) && toast(message, optionsSuccess);
};
export const ToastNotifyError = (message: string) => {
  !toast.isActive(customId) &&
    canBeRendered(message) &&
    toast(message, optionsError);
};
